module.exports = __webpack_public_path__ + "b85314fb4ffe4e09e1e1f6375eff09a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/leaf.png
// module id = 1829
// module chunks = 1